<template>
  <div class="board-column" :style="{ backgroundColor: column.bgColor }">
    <!-- 母卡 Header -->
    <div class="column-header">
      <span class="column-title">{{ column.title }}</span>
      <div class="column-header-right">
        <span class="card-count">{{ activeCards.length }}</span>
      </div>
    </div>

    <!-- 子卡 Body (可拖拽區域) -->
    <draggable
      :list="column.cards"
      group="cards"
      ghost-class="ghost-card"
      class="card-list"
      @change="$emit('drag-change', $event, column.id)"
    >
      <card-item
        v-for="card in column.cards"
        v-show="!card.archived"
        :key="card.id"
        :card="card"
        :member-options="memberOptions"
        @click="$emit('card-click', card, column)"
        @toggle-check="$emit('card-toggle-check', $event)"
        @archive="$emit('card-archive', $event)"
      />
    </draggable>

    <!-- 最下方：新增卡片區域 -->
    <div class="add-card-wrapper">
      <div v-if="actionColumn.isAdding" class="add-card-form">
        <el-input
          type="textarea"
          :rows="2"
          placeholder="輸入標題或黏貼連結"
          v-model="actionColumn.newCardTitle"
          @keyup.enter.native.exact.prevent="confirmAddCard"
        ></el-input>
        <div class="add-card-actions">
          <el-button type="primary" size="mini" @click="confirmAddCard">添加卡片</el-button>
          <i class="el-icon-close cancel-btn" @click="cancelAddCard"></i>
        </div>
      </div>
      <div v-else class="add-card-btn" @click="startAddCard">
        <i class="el-icon-plus"></i> 添加卡片
      </div>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import CardItem from './cardItem.vue'

export default {
  name: 'BoardColumn',
  components: { draggable, CardItem },
  props: {
    column: { type: Object, required: true },
    actionColumn: { type: Object, required: true },
    memberOptions: { type: Array, default: () => [] },
  },
  computed: {
    activeCards() {
      return this.column.cards ? this.column.cards.filter(c => !c.archived) : []
    },
  },
  methods: {
    startAddCard() {
      this.actionColumn.isAdding = true
      this.actionColumn.newCardTitle = ''
    },
    cancelAddCard() {
      this.actionColumn.isAdding = false
      this.actionColumn.newCardTitle = ''
    },
    confirmAddCard() {
      if (!this.actionColumn.newCardTitle.trim()) {
        this.cancelAddCard()
        return
      }
      this.$emit('add-card', {
        column: this.column,
        title: this.actionColumn.newCardTitle.trim(),
      })
      this.cancelAddCard()
    },
  },
}
</script>

<style scoped lang="scss">
.board-column {
  width: 280px;
  min-width: 160px;
  background-color: #f1f2f4;
  border-radius: 8px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  max-height: calc(80vh - 12px);
  height: fit-content;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25);
  margin-bottom: 12px;
}
.column-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;
  padding: 10px 10px 16px;
}
.card-list {
  flex: 1;
  overflow-y: auto;
}
.add-card-wrapper {
  margin-top: 8px;
}
.add-card-btn {
  padding: 6px;
  cursor: pointer;
  border-radius: 4px;
  color: #333333;
  &:hover {
    border-color: #409eff;
  }
}
.add-card-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 6px;
}
.cancel-btn {
  font-size: 18px;
  cursor: pointer;
  color: #aaa;
}
.ghost-card {
  opacity: 0.5;
  background: #bdbdbd !important;
}
</style>
